import { useContext } from 'react';

import type { AgentVersioningConfig } from '../../types';

import { agentVersioningConfigContext } from './agentVersioningConfigContext';

export const useAgentVersioningConfig = (): AgentVersioningConfig | undefined =>
	useContext(agentVersioningConfigContext);
